import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import {
	getFilteredCurrentDataBasedOnLevel,
	handleFilterItemSearch
} from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeSelectedCategory } from '@store/actions/FilterAction';

const MultiLayerFilter = ({
	filterOptions,
	selectedField,
	selectedMultilevelData,
	allOptions,
	setFilterOptions,
	currentSelectedFilterLevel,
	type,
	isOpenFourthLayerOnSearch = false,
	isReplaceHyphens = true
}) => {
	const ref = useRef();
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);
	const dispatch = useDispatch();

	const onOutSideClick = () => {
		if (selectedCheckboxField === type) dispatch(clearSelectedFilterName());
	};

	const updateSelectedOptionBasedOnSearch = (nextFilterLevel, item) => {
		dispatch(
			storeSelectedCategory({
				...item,
				filterLevel: nextFilterLevel
			})
		);
	};

	useClickOutside(ref, onOutSideClick);

	return (
		<div ref={ref}>
			<FilterName type={type} data={filterOptions} />
			<Checkbox
				data={filterOptions}
				type={type}
				handleSearch={(e) =>
					handleFilterItemSearch(
						e,
						allOptions,
						setFilterOptions,
						updateSelectedOptionBasedOnSearch,
						isOpenFourthLayerOnSearch
					)
				}
				nextFilterLevel={3}
				className="filter-submenu scroll-y-label"
				isFocus={true}
				showSearchBar={true}
				isReplaceHyphens={isReplaceHyphens}
			/>

			{selectedField?.selectedCheckboxField &&
				type === selectedCheckboxField &&
				[3, 4].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '235px' }}>
						<Checkbox
							isPrimary={false}
							data={getFilteredCurrentDataBasedOnLevel(3, selectedMultilevelData)}
							type={type}
							nextFilterLevel={4}
							className="" // Do not remove or modify this. Removing it will cause CheckBox to use the default className='filter-submenu scroll-y-label'.
							isFocus={false}
							showSearchBar={false}
							isReplaceHyphens={isReplaceHyphens}
						/>
					</div>
				)}

			{selectedField?.selectedCheckboxField &&
				type === selectedCheckboxField &&
				[4].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '470px' }}>
						<Checkbox
							isPrimary={false}
							data={getFilteredCurrentDataBasedOnLevel(4, selectedMultilevelData)}
							type={type}
							nextFilterLevel={5}
							className="" // Do not remove or modify this. Removing it will cause CheckBox to use the default className='filter-submenu scroll-y-label'
							isFocus={false}
							showSearchBar={false}
							isReplaceHyphens={isReplaceHyphens}
						/>
					</div>
				)}
		</div>
	);
};

export default MultiLayerFilter;
